import { CreateProjectSubmitResponse } from '@adsk/acs-admin-ui-components';

import i18n from '../helpers/i18n';

export const getProjectCreateErrorMessage = (
  createProjectResponse: CreateProjectSubmitResponse,
) => {
  // Default Response
  const defaultErrorMessage = i18n.t(
    'PROJECT_COULD_NOT_BE_CREATED_CONTACT_SUPPORT',
  );

  // Validate the createProjectResponse
  if (
    Object.keys(createProjectResponse).length === 0 ||
    !createProjectResponse.response
  ) {
    return defaultErrorMessage;
  }

  // Handle 403
  if (createProjectResponse.response.status === 403) {
    return i18n.t('PROJECT_COULD_NOT_BE_CREATED_PERMISSION_DENIED');
  }

  // Handle 400
  if (createProjectResponse.response.status === 400) {
    if (createProjectResponse.response.errors) {
      const invalidField = createProjectResponse.response.errors[0].field;
      if (invalidField === 'country') {
        return i18n.t('PROJECT_COULD_NOT_BE_CREATED_COUNTRY_NOT_VALID');
      } else if (invalidField === 'stateOrProvince') {
        return i18n.t(
          'PROJECT_COULD_NOT_BE_CREATED_COUNTRY_AND_STATE_INCOMPATIBLE',
        );
      }
    } else if (
      createProjectResponse.response.detail?.indexOf('currency') === 0
    ) {
      return i18n.t('PROJECT_COULD_NOT_BE_CREATED_CURRENCY_NOT_VALID');
    }
  }
  return defaultErrorMessage;
};
